import React from 'react'

export default function ButtonIcon({ icon: Icon, title, bouncing, onClick }) {
  return (
        <button
            onClick={onClick}
            className="flex w-10 h-10 mx-4 mt-2 bg-white/10 backdrop-blur-sm rounded-full items-center justify-center text-orange-400 hover:bg-white/20 transition-all duration-300 border border-white/20 hover:scale-110"
            title={title}
        >
            <Icon size={24} className={`
                ${bouncing
                    ? 'animate-bounce'
                    : ''
                }`} />
        </button>
  )
}
